<template>
    <div class="visa_card_container">
        <div class="visa_card">
            <div class="visa_card_heading">
                Visa Processing
            </div>
            <div class="if_visa" v-if="visa">
                <div class="visa_card_universities_wrapper">
                    <div class="visa_card_universities">
                        <i class="material-icons"> school </i>
                        <span class="visa_university_title"> <span v-if="visa.university" >{{visa.university}} </span><span v-else>N/a</span></span>
                    </div>
                </div>
                <div class="visa_body_card">
                    <div class="cms_timeline">
                        <div class="timeline_process" v-for="(sts, index) in visa.country_status" :key="index" :class="visa.status === sts.status ? 'active_timeline' : ''">
                            <span class="timeline_name"> {{sts.status}}</span>
                        </div>
                    </div> 
                    <div class="visa_process_details">
                        <div class="visa_process_info"><!----> 
                            <div class="visa_college_info visa_info_wrap">
                                <div class="visa_info_head"> College / University</div>
                                <div class="visa_info"><span v-if="visa.university" >{{visa.university}} </span><span v-else>N/a</span></div>
                            </div> 
                            <div class="visa_college_info visa_info_wrap">
                                <div class="visa_info_head"> Course</div> 
                                <div class="visa_info"> <span v-if="visa.course" >{{visa.course}} </span><span v-else>N/a</span></div>
                            </div> 
                            <div class="visa_country_info visa_info_wrap">
                                <div class="visa_info_head"> Country</div>
                                <div class="visa_info"> <span v-if="visa.country" >{{visa.country}} </span><span v-else>N/a</span></div>
                            </div> 
                            <div class="visa_country_info visa_info_wrap">
                                <div class="visa_info_head"> Level</div>
                                <div class="visa_info"> 
                                    {{visa.visa.level}}
                                    <!-- <span v-if="visa.visa.level" >{{visa.visa.level}}</span><span v-else>N/a</span> -->
                                    </div>
                            </div> 
                            <div class="visa_intake_info visa_info_wrap">
                                <div class="visa_info_head"> Intake Period</div>
                                <div class="visa_info"> {{ visa.visa.intake_period }}
                                <span> {{visa.visa.intake_date}} </span>
                                </div>
                            </div>
                        </div>  
                    </div>
                </div>
            </div>
            <div class="no_visa" v-else >
                No Visa Processings
            </div>
        </div> 
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
    computed: {
        ...mapGetters(['visa'])
    },
}
</script>



// WEBPACK FOOTER //
// src/components/VisaDetail/VisaCard.vue